import { useState, useEffect, useRef } from "react";
import styles from "./SortDropdown.module.css";

const SORT_OPTIONS = [
  { label: "Date added", value: "date" },
  { label: "Name A–Z", value: "name_asc" },
  { label: "Name Z–A", value: "name_desc" },
  // { label: "Price: Low to High", value: "price_asc" },
  // { label: "Price: High to Low", value: "price_desc" },
];

const SortDropdown = ({ sort, onSortChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSortChange = (newSort) => {
    onSortChange(newSort);
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  const currentOption = SORT_OPTIONS.find(opt => opt.value === sort) || SORT_OPTIONS[0];

  return (
    <div className={styles.sortDropdown} ref={dropdownRef}>
      <button
        type="button"
        className={styles.sortDropdownButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 7L12 12L17 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7 13L12 18L17 13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span>{currentOption.label}</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L12 15L18 9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {isOpen && (
        <div className={styles.sortDropdownMenu} role="listbox">
          {SORT_OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`${styles.sortDropdownItem} ${sort === option.value ? styles.active : ''}`}
              onClick={() => handleSortChange(option.value)}
              role="option"
              aria-selected={sort === option.value}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
